import { useState, useEffect } from "react";
import "./analyticsInfo.css";
import { useSelector, useDispatch } from "react-redux";
import { updatefinancialAnalysis, updateTcy } from "../../../Features/roofInfo";
import CustomInput from "../../../component/customInput";
import Grid from "@mui/material/Grid2";
import { Autocomplete, TextField } from "@mui/material";
import CustomInputLabel from "../../../component/customInputLabel";

export default function InfoContainer({ emptyValues }) {
  const dispatch = useDispatch();
  const roofInfo = useSelector((state) => state.roof);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (value === "" || isNaN(parseInt(value))) {
      dispatch(updatefinancialAnalysis({ [name]: 0 }));
    } else {
      dispatch(updatefinancialAnalysis({ [name]: parseInt(value) }));
    }
    handleTCY();
  };

  const handleOptionChange = (event, newValue) => {
    let hardcodedValues = {};

    if (newValue) {
      switch (newValue.label) {
        case "Commercial":
          hardcodedValues = {
            jan: 2162,
            feb: 2233,
            mar: 2183,
            apr: 2334,
            may: 2580,
            jun: 2788,
            jul: 2812,
            aug: 2734,
            sep: 2533,
            oct: 2232,
            nov: 2102,
            dec: 2099,
          };
          break;
        case "Residential":
          hardcodedValues = {
            jan: 872,
            feb: 753,
            mar: 912,
            apr: 853,
            may: 957,
            jun: 1065,
            jul: 1123,
            aug: 1051,
            sep: 953,
            oct: 923,
            nov: 822,
            dec: 851,
          };
          break;
        case "Industrial":
          hardcodedValues = {
            jan: 7888,
            feb: 7986,
            mar: 8102,
            apr: 8312,
            may: 8513,
            jun: 8810,
            jul: 9201,
            aug: 8912,
            sep: 8523,
            oct: 8232,
            nov: 8092,
            dec: 7988,
          };
          break;
        default:
          break;
      }

      // Update the Redux store with hardcoded values
      Object.keys(hardcodedValues).forEach((month) => {
        dispatch(updatefinancialAnalysis({ [month]: hardcodedValues[month] }));
      });
      handleTCY(); // Update the total consumption
    }
  };

  useEffect(() => {
    handleTCY();
     // eslint-disable-next-line
  }, [roofInfo]); // Add roofInfo as a dependency

  const options = [
    { label: "Residential" },
    { label: "Commercial" },
    { label: "Industrial" },
  ];

  const totalValues =
    roofInfo.value.financialAnalysis.jan +
    roofInfo.value.financialAnalysis.feb +
    roofInfo.value.financialAnalysis.mar +
    roofInfo.value.financialAnalysis.apr +
    roofInfo.value.financialAnalysis.may +
    roofInfo.value.financialAnalysis.jun +
    roofInfo.value.financialAnalysis.jul +
    roofInfo.value.financialAnalysis.aug +
    roofInfo.value.financialAnalysis.sep +
    roofInfo.value.financialAnalysis.oct +
    roofInfo.value.financialAnalysis.nov +
    roofInfo.value.financialAnalysis.dec;

  const [totalConsumption, setTotalConsumption] = useState(totalValues);

  const handleTCY = () => {
    setTotalConsumption(totalValues);
    dispatch(updateTcy(totalValues));
  };

  return (
    <div className="AinfoContainer">
      <div className="siteDetail">
        <h1>Enter Monthly Consumption</h1>
        <CustomInputLabel title={"Monthly Consumption (kWh)"} />
        <Grid container spacing={2} sx={{ marginBottom: "10px" }}>
          <Autocomplete
            disablePortal
            options={options}
            getOptionLabel={(option) => option.label}
            onChange={handleOptionChange} // Update this line
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select Area Type"
                variant="outlined"
              />
            )}
            style={{ width: 300, marginTop: 10 }}
          />

          {/* Input fields for each month explicitly defined */}
          <CustomInput
            id="jan"
            name="jan"
            value={roofInfo.value.financialAnalysis.jan}
            onChange={(e) => handleInputChange(e)}
            required={true}
            placeholder="Jan"
            width="110px"
            adornmentValue={"Jan"}
            adornmentRequired={true}
            titleRequired={false}
          />
          <CustomInput
            id="feb"
            name="feb"
            value={roofInfo.value.financialAnalysis.feb}
            onChange={(e) => handleInputChange(e)}
            required={true}
            placeholder="Feb"
            width="110px"
            adornmentValue={"Feb"}
            adornmentRequired={true}
            titleRequired={false}
          />
          <CustomInput
            id="mar"
            name="mar"
            value={roofInfo.value.financialAnalysis.mar}
            onChange={(e) => handleInputChange(e)}
            required={true}
            placeholder="Mar"
            width="110px"
            adornmentValue={"Mar"}
            adornmentRequired={true}
            titleRequired={false}
          />
          <CustomInput
            id="apr"
            name="apr"
            value={roofInfo.value.financialAnalysis.apr}
            onChange={(e) => handleInputChange(e)}
            required={true}
            placeholder="Apr"
            width="110px"
            adornmentValue={"Apr"}
            adornmentRequired={true}
            titleRequired={false}
          />
          <CustomInput
            id="may"
            name="may"
            value={roofInfo.value.financialAnalysis.may}
            onChange={(e) => handleInputChange(e)}
            required={true}
            placeholder="May"
            width="110px"
            adornmentValue={"May"}
            adornmentRequired={true}
            titleRequired={false}
          />
          <CustomInput
            id="jun"
            name="jun"
            value={roofInfo.value.financialAnalysis.jun}
            onChange={(e) => handleInputChange(e)}
            required={true}
            placeholder="Jun"
            width="110px"
            adornmentValue={"Jun"}
            adornmentRequired={true}
            titleRequired={false}
          />
          <CustomInput
            id="jul"
            name="jul"
            value={roofInfo.value.financialAnalysis.jul}
            onChange={(e) => handleInputChange(e)}
            required={true}
            placeholder="Jul"
            width="110px"
            adornmentValue={"Jul"}
            adornmentRequired={true}
            titleRequired={false}
          />
          <CustomInput
            id="aug"
            name="aug"
            value={roofInfo.value.financialAnalysis.aug}
            onChange={(e) => handleInputChange(e)}
            required={true}
            placeholder="Aug"
            width="110px"
            adornmentValue={"Aug"}
            adornmentRequired={true}
            titleRequired={false}
          />
          <CustomInput
            id="sep"
            name="sep"
            value={roofInfo.value.financialAnalysis.sep}
            onChange={(e) => handleInputChange(e)}
            required={true}
            placeholder="Sep"
            width="110px"
            adornmentValue={"Sep"}
            adornmentRequired={true}
            titleRequired={false}
          />
          <CustomInput
            id="oct"
            name="oct"
            value={roofInfo.value.financialAnalysis.oct}
            onChange={(e) => handleInputChange(e)}
            required={true}
            placeholder="Oct"
            width="110px"
            adornmentValue={"Oct"}
            adornmentRequired={true}
            titleRequired={false}
          />
          <CustomInput
            id="nov"
            name="nov"
            value={roofInfo.value.financialAnalysis.nov}
            onChange={(e) => handleInputChange(e)}
            required={true}
            placeholder="Nov"
            width="110px"
            adornmentValue={"Nov"}
            adornmentRequired={true}
            titleRequired={false}
          />
          <CustomInput
            id="dec"
            name="dec"
            value={roofInfo.value.financialAnalysis.dec}
            onChange={(e) => handleInputChange(e)}
            required={true}
            placeholder="Dec"
            width="110px"
            adornmentValue={"Dec"}
            adornmentRequired={true}
            titleRequired={false}
          />
        </Grid>
        <CustomInputLabel
          title={"Yearly Consumption (kWh)"}
          isRequired={false}
        />
        <TextField
          placeholder="total consumption"
          fullWidth
          disabled
          variant="outlined"
          value={totalConsumption}
          sx={{ backgroundColor: "#E9ECEF" }}
        />
      </div>
    </div>
  );
}
